
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const sections = [
  {
    icon: 'ri-eye-line',
    title: '1. Genel Bakış',
    content: `Bu Gizlilik Politikası, Microsoft Security Blog web sitesini ("Site") ziyaret ettiğinizde kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklamaktadır. Siteyi kullanarak bu politikayı kabul etmiş sayılırsınız. Politikamız, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve Avrupa Birliği Genel Veri Koruma Tüzüğü (GDPR) ilkelerine uygun olarak hazırlanmıştır.`
  },
  {
    icon: 'ri-database-2-line',
    title: '2. Toplanan Veriler',
    content: `Sitemiz aşağıdaki verileri toplayabilir: Bülten aboneliği için sağladığınız e-posta adresi; iletişim formları aracılığıyla paylaştığınız ad, e-posta ve mesaj içeriği; tarayıcı türü, işletim sistemi, IP adresi ve ziyaret edilen sayfalar gibi otomatik olarak toplanan teknik veriler; çerezler ve benzeri teknolojiler aracılığıyla toplanan kullanım verileri. Kredi kartı bilgisi, kimlik numarası veya hassas kişisel veri toplanmamaktadır.`
  },
  {
    icon: 'ri-settings-4-line',
    title: '3. Verilerin Kullanım Amaçları',
    content: `Toplanan kişisel veriler şu amaçlarla kullanılmaktadır: Bülten aboneliği kapsamında yeni makale ve güvenlik güncellemesi bildirimleri göndermek; site performansını analiz etmek ve kullanıcı deneyimini iyileştirmek; teknik sorunları tespit etmek ve gidermek; yasal yükümlülükleri yerine getirmek; iletişim taleplerinize yanıt vermek. Verileriniz hiçbir koşulda üçüncü taraflara satılmaz veya ticari amaçla paylaşılmaz.`
  },
  {
    icon: 'ri-cookie-line',
    title: '4. Çerezler (Cookies)',
    content: `Sitemiz, kullanıcı deneyimini geliştirmek amacıyla çerezler kullanmaktadır. Zorunlu çerezler sitenin düzgün çalışması için gereklidir ve devre dışı bırakılamaz. Analitik çerezler, ziyaretçi istatistiklerini anonim olarak toplamak için kullanılır. Tercih çerezleri, dil ve tema gibi kullanıcı tercihlerinizi hatırlamak için kullanılabilir. Tarayıcı ayarlarınızdan çerezleri yönetebilir veya silebilirsiniz; ancak bu durumda bazı site özellikleri düzgün çalışmayabilir.`
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '5. Analitik ve İzleme',
    content: `Site trafiğini analiz etmek için Google Analytics veya benzeri analitik araçlar kullanılabilir. Bu araçlar, ziyaretçi sayısı, sayfa görüntüleme, oturum süresi ve coğrafi konum gibi anonim istatistiksel veriler toplar. Bu veriler bireysel kullanıcıları tanımlamak için kullanılmaz ve yalnızca site içeriğini ve performansını iyileştirmek amacıyla değerlendirilir.`
  },
  {
    icon: 'ri-share-forward-line',
    title: '6. Üçüncü Taraf Hizmetler',
    content: `Sitemiz, GitHub, LinkedIn, YouTube ve Twitter gibi üçüncü taraf platformlara bağlantılar içerebilir. Bu platformlara yönlendirildiğinizde, ilgili platformun kendi gizlilik politikası geçerli olur. Ayrıca site altyapısı için kullanılan barındırma, e-posta gönderim ve analitik hizmet sağlayıcıları, yalnızca hizmet sunumu kapsamında ve gizlilik sözleşmeleri çerçevesinde verilerinize erişebilir.`
  },
  {
    icon: 'ri-lock-line',
    title: '7. Veri Güvenliği',
    content: `Kişisel verilerinizin güvenliğini sağlamak için endüstri standardı teknik ve idari önlemler uygulanmaktadır. SSL/TLS şifreleme ile veri iletimi korunmaktadır. Erişim kontrolleri ve güvenlik duvarları kullanılmaktadır. Düzenli güvenlik değerlendirmeleri yapılmaktadır. Ancak internet üzerinden hiçbir veri iletim yönteminin %100 güvenli olmadığını hatırlatmak isteriz. Olası bir veri ihlali durumunda, etkilenen kullanıcılar yasal süreler içinde bilgilendirilecektir.`
  },
  {
    icon: 'ri-time-line',
    title: '8. Veri Saklama Süresi',
    content: `Kişisel verileriniz, toplanma amacının gerektirdiği süre boyunca saklanır. Bülten abonelik verileri, abonelik iptal edilene kadar tutulur. İletişim formu verileri, talebin yanıtlanmasından itibaren en fazla 1 yıl saklanır. Analitik veriler anonim hale getirilerek 26 ay süreyle tutulur. Saklama süresi dolan veriler güvenli bir şekilde silinir veya anonim hale getirilir.`
  },
  {
    icon: 'ri-user-settings-line',
    title: '9. Haklarınız',
    content: `KVKK ve GDPR kapsamında aşağıdaki haklara sahipsiniz: Kişisel verilerinizin işlenip işlenmediğini öğrenme hakkı; işlenen verileriniz hakkında bilgi talep etme hakkı; verilerinizin düzeltilmesini veya silinmesini isteme hakkı; veri işlemeye itiraz etme hakkı; veri taşınabilirliği hakkı; bülten aboneliğinden istediğiniz zaman çıkma hakkı. Bu haklarınızı kullanmak için ozgur@ozgurcebi.com adresine başvurabilirsiniz. Talepleriniz en geç 30 gün içinde yanıtlanacaktır.`
  },
  {
    icon: 'ri-refresh-line',
    title: '10. Politika Güncellemeleri',
    content: `Bu Gizlilik Politikası, yasal düzenlemeler veya site işleyişindeki değişiklikler doğrultusunda güncellenebilir. Önemli değişiklikler yapıldığında, sitede bir bildirim yayınlanacaktır. Güncellenmiş politika, sitede yayınlandığı tarihten itibaren geçerli olur. Politikayı düzenli olarak gözden geçirmenizi öneririz.`
  },
  {
    icon: 'ri-mail-line',
    title: '11. İletişim',
    content: `Gizlilik politikamız hakkında sorularınız, talepleriniz veya şikayetleriniz için aşağıdaki kanallardan bize ulaşabilirsiniz. E-posta: ozgur@ozgurcebi.com. Konum: İstanbul, Türkiye. Veri sorumlusu olarak tüm taleplerinizi ciddiyetle değerlendirip en kısa sürede yanıtlayacağız.`
  }
];

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F1419] via-[#1A2332] to-[#0F1419]" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
        <div
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage:
              'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)'
          }}
        />

        <div className="relative max-w-4xl mx-auto px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg mb-6">
              <i className="ri-shield-keyhole-line text-emerald-400 mr-2"></i>
              <span className="text-emerald-400 text-sm font-medium">Gizlilik</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Gizlilik Politikası
            </h1>
            <p className="text-lg text-white/70 max-w-2xl mx-auto">
              Kişisel verilerinizin nasıl toplandığını, kullanıldığını ve korunduğunu öğrenmek için lütfen bu politikayı dikkatlice okuyunuz.
            </p>
            <p className="text-sm text-white/40 mt-6">
              Son güncelleme: 1 Temmuz 2025
            </p>
          </motion.div>
        </div>
      </section>

      {/* İçerik */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-8">
          {/* Özet Kutusu */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="bg-emerald-50 border border-emerald-100 rounded-xl p-6 mb-14"
          >
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 flex items-center justify-center mt-0.5">
                <i className="ri-information-line text-emerald-600 text-xl"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-emerald-900 mb-1">Özet</h3>
                <p className="text-sm text-emerald-800 leading-relaxed">
                  Yalnızca bülten aboneliği ve iletişim formu aracılığıyla sınırlı kişisel veri topluyoruz. Verileriniz üçüncü taraflara satılmaz. KVKK ve GDPR kapsamındaki tüm haklarınızı kullanabilirsiniz. Detaylar için aşağıdaki bölümleri inceleyiniz.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Bölümler */}
          <div className="space-y-10">
            {sections.map((section, index) => (
              <motion.article
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
              >
                <div className="flex items-start space-x-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${section.icon} text-gray-700 text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-3">
                      <a
                        href={`#privacy-section-${index + 1}`}
                        className="hover:text-emerald-600 transition-colors"
                      >
                        {section.title}
                      </a>
                    </h4>
                    <p className="text-[15px] text-gray-600 leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
                {index < sections.length - 1 && (
                  <div className="border-b border-gray-100 mt-10 ml-14"></div>
                )}
              </motion.article>
            ))}
          </div>

          {/* Alt Bilgi */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mt-16 pt-10 border-t border-gray-200"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <Link
                  to="/terms"
                  className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  <i className="ri-file-shield-2-line mr-1"></i>
                  Kullanım Koşulları
                </Link>
                <span className="text-gray-300">|</span>
                <Link
                  to="/"
                  className="text-sm text-gray-500 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  <i className="ri-home-4-line mr-1"></i>
                  Ana Sayfa
                </Link>
              </div>
              <p className="text-sm text-gray-400">
                &copy; 2025 Microsoft Security Blog
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
